import React from "react";

import ByosRoot from "../byos/component/ByosRoot";

export default class Index extends React.Component {
  render() {
    return <ByosRoot />;
  }
}



// WEBPACK FOOTER //
// ./src/pages/build-your-own-starter.js